import { LockKeyhole, ShieldCheck, User } from "lucide-react";
import { Link } from "react-router-dom";

type AdminAuthPageProps = {
  mode: "login" | "2fa";
};

export function AdminAuthPage({ mode }: AdminAuthPageProps) {
  const is2fa = mode === "2fa";

  return (
    <main className="admin-auth">
      <section className="admin-auth-card">
        <div>
          <ShieldCheck aria-hidden="true" />
          <h1>{is2fa ? "Xác minh 2FA" : "Đăng nhập admin"}</h1>
          <p>
            Admin bắt buộc email + password và 2FA. Không cho phép bỏ qua bước xác minh.
          </p>
        </div>
        <form onSubmit={(event) => event.preventDefault()}>
          <label>
            Email admin
            <span>
              <User aria-hidden="true" />
              <input defaultValue="admin@sieuthiuathich.local" type="email" />
            </span>
          </label>
          <label>
            {is2fa ? "Mã 2FA" : "Mật khẩu"}
            <span>
              <LockKeyhole aria-hidden="true" />
              <input type={is2fa ? "text" : "password"} placeholder={is2fa ? "6 số" : "Mật khẩu"} />
            </span>
          </label>
          <Link className="btn btn-primary" to={is2fa ? "/admin" : "/admin/2fa"}>
            <span>{is2fa ? "Vào admin" : "Tiếp tục 2FA"}</span>
          </Link>
        </form>
      </section>
    </main>
  );
}
